export default "__VITE_ASSET__b0eecc02__"